import { AlertTriangle } from "lucide-react";

export const inr = (v, d = 2) =>
  v === null || v === undefined ? null
    : `${Number(v) < 0 ? "-" : ""}₹${Math.abs(Number(v)).toLocaleString("en-IN", { minimumFractionDigits: d, maximumFractionDigits: d })}`;

export const qtyFmt = (v, d = 3) =>
  v === null || v === undefined ? "—" : Number(v).toLocaleString("en-IN", { maximumFractionDigits: d });

export function Missing({ text, testId }) {
  return (
    <span data-testid={testId} className="inline-flex items-center gap-1 text-xs font-semibold text-amber-700">
      <AlertTriangle className="h-3.5 w-3.5" /> {text}
    </span>
  );
}

export function Stat({ label, value, missing, sub, testId, strong }) {
  return (
    <div data-testid={testId} className="min-w-0">
      <div className="text-[10px] font-semibold uppercase tracking-wider text-stone-500">{label}</div>
      <div className={`mt-1 font-mono ${strong ? "text-lg font-bold" : "text-sm font-semibold"} text-stone-900`}>
        {value ?? <Missing text={missing || "Not available"} />}
      </div>
      {sub && <div className="mt-0.5 text-[11px] text-stone-500">{sub}</div>}
    </div>
  );
}

export function Section({ title, right, children, testId }) {
  return (
    <div className="rounded-xl border border-stone-200 bg-white shadow-sm" data-testid={testId}>
      <div className="flex flex-wrap items-center justify-between gap-2 border-b border-stone-100 px-5 py-3">
        <h3 className="font-display text-sm font-semibold uppercase tracking-wide text-stone-800">{title}</h3>
        {right}
      </div>
      <div className="p-5">{children}</div>
    </div>
  );
}

const STATUS = {
  OK: ["Verified", "bg-emerald-50 text-emerald-700 border-emerald-200"],
  ZERO_COST_WATER: ["Water ₹0", "bg-sky-50 text-sky-700 border-sky-200"],
  NOT_IN_MASTER: ["Snapshot rate", "bg-amber-50 text-amber-700 border-amber-200"],
  UNIT_REVIEW: ["UNIT_REVIEW", "bg-rose-50 text-rose-700 border-rose-200"],
  PRICE_MISSING: ["PRICE MISSING", "bg-rose-50 text-rose-700 border-rose-200"],
};

export function LineStatus({ status, testId }) {
  const [label, cls] = STATUS[status] || [status, "bg-stone-50 text-stone-600 border-stone-200"];
  return <span data-testid={testId} className={`whitespace-nowrap rounded border px-1.5 py-0.5 text-[10px] font-bold ${cls}`}>{label}</span>;
}
